import { isDropTarget } from "shared/types/drag-and-drop/DropTarget"

import { TableDragMetaSchema } from "../types/TableDragMeta"

export function isTableDropTarget(target: unknown) {
  return isDropTarget(target, { metaSchema: TableDragMetaSchema })
}
